var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFilesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6229 12.4492V19.6495C24.6229 20.1554 24.5262 20.6564 24.3383 21.1239C24.1505 21.5913 23.8752 22.016 23.5281 22.3738C23.1809 22.7315 22.7689 23.0152 22.3154 23.2088C21.8619 23.4024 21.3759 23.5019 20.885 23.5018H5.19342C4.70259 23.5019 4.21656 23.4024 3.76306 23.2088C3.30957 23.0152 2.89751 22.7315 2.5504 22.3738C2.2033 22.016 1.92796 21.5913 1.74011 21.1239C1.55225 20.6564 1.45557 20.1554 1.45557 19.6495V12.4492",
    stroke: "#DE1186",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26221 6.42652L13.0394 1.50195L17.8166 6.42652",
    stroke: "#DE1186",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0396 17.9741V1.50195",
    stroke: "#DE1186",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFilesIcon);
export default __webpack_public_path__ + "static/media/upload-files-icon.b8c890b91873365f3a48c8dd90716370.svg";
export { ForwardRef as ReactComponent };